import React, { useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  FormControl,
  InputLabel,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { handleApplyFilterItemFunction } from "./FiltersContainer";
import { IOptionSchema, OperatorEnum } from "../../../../utils/types";
import { useNotificationContext } from "../../../../context/notificationContext";

interface TextFilterProps {
  handleApplyFilter: handleApplyFilterItemFunction;
  value: string;
  columnName: string;
  operator: string;
}

const operatorOptions: IOptionSchema[] = [
  { value: OperatorEnum.IS_EQUAL, label: "مساوی" },
  { value: OperatorEnum.IS_GREATER_THAN_OR_EQUAL_TO, label: "بزرگتر یا مساوی" },
  { value: OperatorEnum.IS_GREATER_THAN_OR_NULL, label: "بزرگتر یا خالی" },
  { value: OperatorEnum.IS_GREATER_THAN, label: "بزرگتر از" },
  { value: OperatorEnum.IS_LESS_THAN_OR_EQUAL_TO, label: "کوچکتر یا مساوی" },
  { value: OperatorEnum.IS_LESS_THAN, label: "کوچکتر از" },
  { value: OperatorEnum.IS_LESS_THAN_OR_NULL, label: "کوچکتر یا خالی" },
];

const NumberFilter = ({
  handleApplyFilter,
  value,
  operator: operatorValue,
  columnName,
}: TextFilterProps) => {
  const { setNotification } = useNotificationContext();
  const operatorOption = operatorOptions.find(
    (opt) => opt.value === operatorValue
  );

  const [inputValue, setInputValue] = useState<string>(value);
  const [operator, setOperator] = useState<string>(
    operatorOption?.value || operatorOptions[0].value
  );

  const applyHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (inputValue?.trim()) {
      handleApplyFilter(columnName, operator, inputValue.trim());
    } else {
      setNotification({
        message: "لطفا مقدار فیلتر را وارد نمایید",
        type: "error",
      });
    }
  };

  const inputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const selectOperatorHandler = (event: SelectChangeEvent<string>) => {
    setOperator(event.target.value);
  };

  return (
    <Box
      component="form"
      onSubmit={applyHandler}
      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
    >
      <FormControl fullWidth size="small" dir="rtl">
        <InputLabel id="operator-select-label">عملگر</InputLabel>
        <Select
          labelId="operator-select-label"
          value={operator}
          label="عملگر"
          onChange={selectOperatorHandler}
          MenuProps={{
            PaperProps: {
              sx: {
                textAlign: "right",
                direction: "rtl",
              },
            },
          }}
        >
          {operatorOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box display="flex" alignItems="center" gap={2}>
        <ArrowForward sx={{ transform: "rotate(180deg)", color: "gray" }} />
        <TextField
          fullWidth
          size="small"
          value={inputValue}
          onChange={inputChangeHandler}
          placeholder="وارد نمایید"
          variant="outlined"
          label="مقدار"
          dir="rtl"
        />
      </Box>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ alignSelf: "flex-start", height: 36 }}
      >
        تایید
      </Button>
    </Box>
  );
};

export default NumberFilter;
